import { render, staticRenderFns } from "./Organizers.vue?vue&type=template&id=4be12be5&scoped=true&"
import script from "./Organizers.vue?vue&type=script&lang=js&"
export * from "./Organizers.vue?vue&type=script&lang=js&"
import style0 from "./Organizers.vue?vue&type=style&index=0&id=4be12be5&prod&lang=scss&scoped=true&"
import style1 from "./Organizers.vue?vue&type=style&index=1&id=4be12be5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be12be5",
  null
  
)

export default component.exports